@if (enabled) {
  <button
    type="button"
    class="transparent-btn"
    (click)="refuseContractModal.openModal()"
    ngbTooltip="Refuser le contrat"
    i18n-ngbTooltip
  >
    <app-cross-icon height="16px" width="16px" color="var(--error-600)" />
  </button>

  <app-action-modal
    #refuseContractModal
    [disabled]="submitted"
    [showHeader]="true"
    headerIconState="error"
    size="md"
    (submitted)="refuseContract()"
  >
    <app-cross-icon
      height="16px"
      width="16px"
      color="var(--error-600)"
      headerIcon
    />
    <ng-container mainTitle i18n
      >Êtes-vous certain de vouloir refuser le contrat&nbsp;?</ng-container
    >
    <ng-container submitButtonLabel i18n>Confirmer</ng-container>
  </app-action-modal>
}
